import { render, staticRenderFns } from "./CommentsTable.vue?vue&type=template&id=b783d1bc&scoped=true&"
import script from "./CommentsTable.vue?vue&type=script&lang=ts&"
export * from "./CommentsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b783d1bc",
  null
  
)

export default component.exports